import React, { createContext, useContext, useEffect, useState } from 'react';
import { isAuthenticated, getUser } from '../lib/auth';
import { CUSTOM_EVENTS } from '../utils/constants';

/**
 * AuthContext provides authentication state across the app
 */
const AuthContext = createContext({
  isAuthenticated: false,
  user: null,
  setUser: () => {}
});

export function AuthProvider({ children }) {
  const [isAuthed, setIsAuthed] = useState(isAuthenticated());
  const [user, setUser] = useState(getUser());

  useEffect(() => {
    const handleAuthChange = () => {
      setIsAuthed(isAuthenticated());
      setUser(getUser());
    };

    const handleLogout = () => {
      setIsAuthed(false);
      setUser(null);
    };

    const handleLogin = () => {
      setIsAuthed(true);
      setUser(getUser());
    };

    // Listen to auth events
    window.addEventListener(CUSTOM_EVENTS.AUTH_LOGIN, handleLogin);
    window.addEventListener(CUSTOM_EVENTS.AUTH_LOGOUT, handleLogout);
    window.addEventListener('storage', handleAuthChange);

    return () => {
      window.removeEventListener(CUSTOM_EVENTS.AUTH_LOGIN, handleLogin);
      window.removeEventListener(CUSTOM_EVENTS.AUTH_LOGOUT, handleLogout);
      window.removeEventListener('storage', handleAuthChange);
    };
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated: isAuthed, user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
